<template>
    <div id="app">
        <answer-header :pathname="pathName"></answer-header>
        <div class="main">
            <router-view></router-view>
        </div>
        <!-- <answer-footer></answer-footer> -->
    </div>
</template>
<script>
import config from './config'
import answerFooter from './components/Footer'
import answerHeader from './components/Header'
var bg = require('./assets/bg.jpg');
var ubg = require('./assets/ubg.jpg');
var welcomebg = require('./assets/welcome.jpg')
export default {
    name: 'App',
    components: { answerFooter,answerHeader },
    computed: {
        pathName(){
            return this.$route.name
        }
    },
    data(){
        return {
            sty: {color: 'red'},
            baseHomeUrl:config.baseHomeUrl,
        }
    },
    created(){
//        this._goCheck();
    },
    methods : {

    }
}

</script>
<style lang="scss">
    body{
        background: url('~@/assets/bg.jpg') repeat-y fixed;
        background-size: rem(750) rem(29);
    }
    #app{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue